/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.9",
    versionName: "0.2.0-nightly.2026.5.9",
    versionChannel: "nightly",
    buildDate: "2026-05-09T00:30:18.028Z",
    commitHash: "d466f4b8c590c5fa4af51e9e702150ddffc9c3d2",
};
